export default __webpack_public_path__ + "static/help_06_02-4-c3be258abac63a7714d78197d4c61c02.png";